import React from 'react';
import Icon from '../../../ui/Icon';
import { ICONS } from '../../../ui/icon-map';

/**
 * One clickable KPI breakdown row: label (+ optional rank / sub line), a count, a share
 * and a thin accent bar. Used by the KPI tabs for type / branch / customer breakdowns.
 */
const ShareRow = ({ label, sub, value, percent, barWidth, onClick, rank, title }) => (
    <button
        type="button"
        onClick={onClick}
        title={title}
        className="w-full text-left flex flex-col gap-1.5 rounded-md p-2 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500"
    >
        <span className="flex justify-between items-center gap-3 w-full">
            <span className="flex items-center gap-3 min-w-0">
                {rank !== undefined && <span className="text-xs text-gray-500 w-4 tabular-nums">{rank}</span>}
                <span className="flex flex-col min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate">{label}</span>
                    {sub && <span className="text-xs text-gray-500">{sub}</span>}
                </span>
            </span>
            <span className="flex items-center gap-2 shrink-0 tabular-nums">
                {value !== undefined && <span className="text-sm text-gray-600">{value}</span>}
                {percent !== undefined && <span className="text-sm font-semibold text-gray-900">{percent}%</span>}
                <Icon glyph={ICONS.chevronRight} size="xs" tone="muted" />
            </span>
        </span>
        {barWidth !== undefined && (
            <span className="block w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--surface-2)' }}>
                <span className="block h-full rounded-full" style={{ width: `${barWidth}%`, backgroundColor: 'var(--accent)' }} />
            </span>
        )}
    </button>
);

export default ShareRow;
